import React, { useState } from "react";
import "../../../../style/main.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ModalHeader, ModalTitle } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const StatsModal = ({ show, handleClose }) => {
  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  return (
    <div>
      {/* Stats Modal  */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <ModalHeader closeButton>
          <ModalTitle> </ModalTitle>
        </ModalHeader>
        <Modal.Body className="stats-modal-body">
          <h4>
            What’s the desired outcome you want your agent to accomplish on this
            call?
          </h4>
          <p>We are going to set up tracking for it:</p>
          <div className="content">
            <div className="desired-outcome">
              <h5>Desired Outcome:</h5>
              <DropdownButton
                id="dropdown-basic-button"
                title="Booked appointment"
              >
                <Dropdown.Item href="#/action-1">
                  Booked appointment
                </Dropdown.Item>
                <Dropdown.Item href="#/action-2">Custom</Dropdown.Item>
              </DropdownButton>
            </div>
            <div className="how">
              <h5>How do you want to track if this outcome is accomplished?</h5>
              <p>Automatic tracking (No setup, highly accurate)</p>
              <span>Tracks by listening to each call recording</span>
            </div>
            <div className="how">
              <p>Verified tracking (advanced setup, almost 100% accurate)</p>
              <span>Tracks using webhooks/api</span>
            </div>
          </div>
          <Button variant="primary" onClick={handleClose} className="mt-5">
            Save & Continue
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StatsModal;
